import { render, staticRenderFns } from "./MonitoredEndpointsCard.vue?vue&type=template&id=023714eb"
import script from "./MonitoredEndpointsCard.vue?vue&type=script&lang=js"
export * from "./MonitoredEndpointsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports